var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaximizeFillIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9662 6.03346C23.333 7.4003 23.333 9.60018 23.333 14C23.333 18.3997 23.333 20.5996 21.9662 21.9665C20.5993 23.3333 18.3994 23.3333 13.9997 23.3333C9.5999 23.3333 7.40001 23.3333 6.03317 21.9665C4.66634 20.5996 4.66634 18.3997 4.66634 14C4.66634 9.60018 4.66634 7.4003 6.03317 6.03346C7.40001 4.66663 9.5999 4.66663 13.9997 4.66663C18.3994 4.66663 20.5993 4.66663 21.9662 6.03346ZM12.833 9.33329C12.833 9.71989 12.5196 10.0333 12.133 10.0333H11.023L13.0946 12.105C13.368 12.3784 13.368 12.8216 13.0946 13.0949C12.8213 13.3683 12.3781 13.3683 12.1047 13.0949L10.033 11.0232V12.1333C10.033 12.5199 9.71961 12.8333 9.33301 12.8333C8.94641 12.8333 8.63301 12.5199 8.63301 12.1333V9.33329C8.63301 8.94669 8.94641 8.63329 9.33301 8.63329H12.133C12.5196 8.63329 12.833 8.94669 12.833 9.33329ZM14.9047 15.8949C14.6313 15.6216 14.6313 15.1784 14.9047 14.905C15.1781 14.6316 15.6213 14.6316 15.8946 14.905L17.9663 16.9767V15.8666C17.9663 15.48 18.2797 15.1666 18.6663 15.1666C19.0529 15.1666 19.3663 15.48 19.3663 15.8666V18.6666C19.3663 19.0532 19.0529 19.3666 18.6663 19.3666H15.8663C15.4797 19.3666 15.1663 19.0532 15.1663 18.6666C15.1663 18.28 15.4797 17.9666 15.8663 17.9666H16.9764L14.9047 15.8949Z",
    fill: "#FFE600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximizeFillIcon);
export default __webpack_public_path__ + "static/media/maximize-fill-icon.245e199538c2bfae1a94b4ae9fa72479.svg";
export { ForwardRef as ReactComponent };